import * as React from 'react';
import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  Button,
  makeStyles,
  tokens,
  Badge,
  Card,
  CardHeader,
  Body1,
  Caption1,
} from '@fluentui/react-components';
import { Edit20Regular } from '@fluentui/react-icons';
import { UserFull } from '../../../types/user';
import { getUserTypeDescription } from '../../../utils/validationUtils';

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  table: {
    // Tabela visível apenas em desktop
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  mobileCards: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'flex',
      flexDirection: 'column',
      gap: tokens.spacingVerticalM,
    },
  },
  card: {
    padding: tokens.spacingHorizontalL,
  },
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
  },
  statusBadge: {
    display: 'flex',
    alignItems: 'center',
  },
});

interface UserGridProps {
  users: UserFull[];
  onEdit: (user: UserFull) => void;
  onNew: () => void;
  loading?: boolean;
}

const UserGrid: React.FC<UserGridProps> = ({ users, onEdit, onNew, loading }) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      {/* Tabela para desktop */}
      <Table className={styles.table}>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>Razão Social</TableHeaderCell>
            <TableHeaderCell>E-mail</TableHeaderCell>
            <TableHeaderCell>Tipo</TableHeaderCell>
            <TableHeaderCell>Status</TableHeaderCell>
            <TableHeaderCell>Ações</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id}>
              <TableCell>{user.razaoSocial}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{getUserTypeDescription(user.tipo)}</TableCell>
              <TableCell>
                <Badge
                  appearance={user.ativo ? 'filled' : 'outline'}
                  color={user.ativo ? 'success' : 'danger'}
                >
                  {user.ativo ? 'Ativo' : 'Inativo'}
                </Badge>
              </TableCell>
              <TableCell>
                <Button
                  appearance="subtle"
                  icon={<Edit20Regular />}
                  onClick={() => onEdit(user)}
                >
                  Editar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Cards para mobile */}
      <div className={styles.mobileCards}>
        {users.map((user) => (
          <Card key={user.id} className={styles.card}>
            <CardHeader
              header={<Body1>{user.razaoSocial}</Body1>}
              description={
                <div>
                  <Caption1>{user.email}</Caption1>
                  <Caption1 style={{ display: 'block', marginTop: tokens.spacingVerticalXXS }}>
                    Tipo: {getUserTypeDescription(user.tipo)}
                  </Caption1>
                </div>
              }
              action={
                <div className={styles.actions}>
                  <Badge
                    appearance={user.ativo ? 'filled' : 'outline'}
                    color={user.ativo ? 'success' : 'danger'}
                  >
                    {user.ativo ? 'Ativo' : 'Inativo'}
                  </Badge>
                  <Button
                    appearance="subtle"
                    icon={<Edit20Regular />}
                    onClick={() => onEdit(user)}
                  >
                    Editar
                  </Button>
                </div>
              }
            />
          </Card>
        ))}
      </div>
    </div>
  );
};

export default UserGrid;